// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"b7c956de","453":"56d7d0e9","809":"944dbeec","929":"26b212f2"}[chunkId] + ".chunk.js";
};